/* eslint-disable no-param-reassign */
import EmailVerificationApi from '@/api/emailVerification'

const _state = {
  // Session-only flag: true once the user has triggered a (re)send from the
  // verification badge in this page session. It flips the badge tooltip from
  // the initial "Verify now" prompt to the "we've sent you an email / Resend"
  // version. Intentionally NOT persisted — it resets to false on refresh by
  // design (a refreshed page goes back to the initial prompt).
  hasRequestedVerification: false,
}

const getters = {
  hasRequestedVerification: (state) => state.hasRequestedVerification,
}

const mutations = {
  setHasRequestedVerification(state, value) {
    state.hasRequestedVerification = value
  },
}

const actions = {
  // Consume the raw token from the verification email link. On success,
  // optimistically flip the cached currentUser flag so any verified-state UI
  // (e.g. the profile badge) updates without refetching the profile — the same
  // store-update approach the name-change flow uses.
  async verifyEmailAction({ commit }, token) {
    const result = await EmailVerificationApi.verifyEmail(token)
    if (result?.verified) {
      commit('updateCurrentUser', { isEmailVerified: true }, { root: true })
    }
    return result
  },

  // (Re)issue a verification email for the authenticated user. Backs both the
  // initial "Verify now" CTA and the subsequent "Resend" link. Returns the raw
  // backend result so callers can surface the right toast.
  async requestVerificationAction({ commit }) {
    const result = await EmailVerificationApi.resendVerification()
    if (result?.alreadyVerified) {
      // Nothing was sent because the address is already verified — reflect that
      // immediately rather than showing the "we've sent you an email" prompt.
      commit('updateCurrentUser', { isEmailVerified: true }, { root: true })
    } else {
      commit('setHasRequestedVerification', true)
    }
    return result
  },
}

export default {
  namespaced: true,
  state: _state,
  getters,
  mutations,
  actions,
}
